import { makeElement } from '../helpers/componentHelpers';
import './LibModal.scss';
import { libToast } from './LibToast';
import { popupIcon } from "../helpers/PopupLevel";
window.modals = [];
function pushModal(modal) {
    return new Promise(((resolve, reject) => {
        var _a;
        (_a = document.body) === null || _a === void 0 ? void 0 : _a.appendChild(modal);
        window.modals.push({ element: modal, promise: { resolve, reject } });
    }));
}
function removeModal(modal) {
    const index = window.modals.findIndex(modalData => modalData.element == modal);
    if (index > -1) {
        window.modals.splice(index, 1);
    }
    modal.remove();
}
function dismissLibModal(modalData, responseData) {
    const innerDiv = modalData.element.querySelector('.lib-modal-inner');
    innerDiv.classList.add('_closed');
    setTimeout(() => {
        removeModal(modalData.element);
        modalData.promise.resolve(responseData);
    }, 100);
}
export function dismissTopLibModal(responseData) {
    const modalData = window.modals.pop();
    if (modalData) {
        dismissLibModal(modalData, responseData);
    }
}
export function dismissAllLibModals() {
    while (window.modals.length > 0) {
        dismissTopLibModal(null);
    }
}
export function libModal(options = {}) {
    var _a;
    const config = Object.assign({}, {
        fromUrl: null,
        fromElement: null,
        fromMarkup: '',
        basicModal: null,
        classes: null,
        loader: { show() { }, hide() { } },
    }, options);
    const { fromUrl, fromElement, fromMarkup, basicModal, classes } = config;
    let markup = fromMarkup;
    if (basicModal) {
        let icon = '';
        if (basicModal.level) {
            icon = `<i class="${popupIcon(basicModal.level)}"></i>`;
        }
        let primaryAction = '';
        if (basicModal.primaryAction) {
            if (basicModal.primaryAction.classes) {
                primaryAction = `<a class="${basicModal.primaryAction.classes} _primary-action" onclick="dismissTopLibModal('primaryAction')">${basicModal.primaryAction.content}</a>`;
            }
            else {
                primaryAction = `<a class="lib-button _primary-action" onclick="dismissTopLibModal('primaryAction')">${basicModal.primaryAction.content}</a>`;
            }
        }
        let secondaryAction = '';
        if (basicModal.secondaryAction) {
            if (basicModal.secondaryAction.classes) {
                secondaryAction = `<div class="_secondary-action"><a class="${basicModal.secondaryAction.classes} _secondary-action" onclick="dismissTopLibModal('secondaryAction')"">${basicModal.secondaryAction.content}</a></div>`;
            }
            else {
                secondaryAction = `<div class="_secondary-action"><a class="lib-link _no-underline _secondary-action" onclick="dismissTopLibModal('secondaryAction')">${basicModal.secondaryAction.content}</a></div>`;
            }
        }
        markup = `
            <div class="lib-stack-modal lib-basic-modal ${basicModal.level ? `_${basicModal.level}` : ""}">
                <h2 class="_title">${icon}${basicModal.title}</h2>
                ${basicModal.bodyMarkup}
                ${primaryAction}
                ${secondaryAction}
            </div>
        `;
    }
    const customClasses = classes === null || classes === void 0 ? void 0 : classes.join(' ');
    const modal = makeElement(`
        <div class="ui-library lib-modal ${customClasses ? customClasses : ''}"> <!-- Add custom classes here -->
            <div class="lib-modal-inner _closed">
                <a class="close-button" href="javascript:void(0)"><i class="fa-regular fa-times"></i></a>
                <div class="lib-modal-content">
                    ${markup}
                </div>
            </div>
        </div>
    `);
    const innerDiv = modal.querySelector('.lib-modal-inner');
    const contentDiv = modal.querySelector('.lib-modal-content');
    const promise = pushModal(modal);
    (_a = modal.querySelector('.close-button')) === null || _a === void 0 ? void 0 : _a.addEventListener('click', () => {
        dismissTopLibModal(null);
    });
    if (fromUrl !== null) {
        let hasReturned = false;
        config.loader.show();
        jQuery(contentDiv).load(fromUrl, (response, status, xhr) => {
            if (!hasReturned) {
                hasReturned = true;
                config.loader.hide();
                if (status === 'error') {
                    removeModal(modal);
                    libToast('error', 'Error', 'An unexpected error occurred.');
                }
                else {
                    innerDiv.classList.remove('_closed');
                }
            }
        });
        setTimeout(function () {
            if (!hasReturned) {
                hasReturned = true;
                config.loader.hide();
                removeModal(modal);
                libToast('error', 'Error', 'An unexpected error occurred. Please contact customer support.');
            }
        }, 5000);
    }
    else if (fromElement != null) {
        const $fromElement = jQuery(fromElement);
        $fromElement.clone(true).appendTo(contentDiv).show();
        const onLaunchFunction = eval($fromElement.data("onlaunch"));
        if (typeof onLaunchFunction === "function") {
            onLaunchFunction(contentDiv);
        }
        innerDiv.classList.remove('_closed');
    }
    else {
        innerDiv.classList.remove('_closed');
    }
    return promise;
}
export function buildLibModal(defaultOptions = {}) {
    return (options) => libModal(Object.assign({}, defaultOptions, options));
}
//# sourceMappingURL=LibModal.js.map